import { PedidoModel } from "../../../../../model/api/pedidos/pedido-model";
import { CardNaoEncontrado } from "../../../../components/cards/card-nao-encontrado";
import { CardPedidoMotoboy } from "../../../../components/cards/card-pedido-motoboy/card-pedido-motoboy";
import { InformacaoIcon } from "../../../../components/icons";

interface PedidoEntregaProps {
    list: Array<PedidoModel>;
    carregando: boolean;
    handleReloadPedidos: () => void;
    pedidoIdParam?: string
}

export const PedidosSemEntregadorData = (props: PedidoEntregaProps) => {

    return (
        <>
            {((props.list ?? []).length === 0) && !props.carregando && (
                <CardNaoEncontrado
                    mensagem="Nenhum pedido encontrado. Só serão exibidos pedidos com status 'Em Entrega' ou 'Enviado'."
                    icon={<InformacaoIcon tipo="GERAL" />}
                />
            )}
            {((props.list ?? []).length > 0) && (
                props.list.map((item) => (
                    <CardPedidoMotoboy
                        key={item.id}
                        pedido={item}
                        handleReloadPedidos={props.handleReloadPedidos}
                        qtdePedidos={props.list.length}
                        pedidoDestaqueProcurado={item.id === props.pedidoIdParam}
                    />
                ))
            )}
        </>
    )
}